import type { SVGProps } from 'react'
const SvgSyShieldDuo = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="m16.487 17.795-3.906 2.79a1 1 0 0 1-1.162 0l-3.906-2.79A6 6 0 0 1 5 12.912V9.15A.15.15 0 0 1 5.15 9h13.7a.15.15 0 0 1 .15.15v3.762a6 6 0 0 1-2.513 4.883" />
		<path
			fillOpacity={0.24}
			d="m15.545 4.52 2.849 1.22a1 1 0 0 1 .606.92v1.19a.15.15 0 0 1-.15.15H5.15A.15.15 0 0 1 5 7.85V6.66a1 1 0 0 1 .606-.92l2.849-1.22a9 9 0 0 1 7.09 0"
		/>
	</svg>
)
export default SvgSyShieldDuo
